import { render, staticRenderFns } from "./openAPP.vue?vue&type=template&id=9740c50e&scoped=true"
import script from "./openAPP.vue?vue&type=script&lang=js"
export * from "./openAPP.vue?vue&type=script&lang=js"
import style0 from "./openAPP.vue?vue&type=style&index=0&id=9740c50e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9740c50e",
  null
  
)

export default component.exports